import {Delete} from '@mui/icons-material';
import {useCan} from 'src/permissions/hooks';
import {IconButton} from '@mui/material';
import {GridRowParams} from '@mui/x-data-grid';
import {FC, useContext} from 'react';
import {useParams} from 'react-router-dom';
import {locationsApi} from 'src/api';
import {useAppDispatch} from 'src/app/hooks';
import {AppDispatch} from 'src/app/store';
import LocationInfoContext from 'src/pages/LocationInfo/LocationInfo.context';
import {preloaderChangeStatus} from 'src/stores/common/commonSlice';
import {isErrorObject} from 'src/utils/helper';
import {NotifyError} from 'src/utils/notification';

type DeleteLocationFileMutationTrigger = ReturnType<
    typeof locationsApi.useDeleteLocationFileMutation
>[0];

const handleDeleteFile =
    (
        trigger: DeleteLocationFileMutationTrigger,
        dispatch: AppDispatch,
        locationId: number,
        fileId: number,
        context: any
    ) =>
        async () => {
            const params = {
                fileId,
                businessId: context.businessId,
            };
            dispatch(preloaderChangeStatus(true));
            try {
                await trigger({locationId, params}).unwrap();
            } catch (error) {
                if (isErrorObject(error)) {
                    NotifyError(error.data.message);
                }
            } finally {
                dispatch(preloaderChangeStatus(false));
            }
        };

export const DeleteFileFromLocationAction: FC<{ row: GridRowParams }> = ({row}) => {
    // The control is the action: without the permission the server refuses it, so showing it
    // offers a button whose only outcome is an error.
    const canDoIt = useCan('locationFiles.delete');
    const {id: locationId} = useParams();
    const [trigger] = locationsApi.useDeleteLocationFileMutation();
    const dispatch = useAppDispatch();
    const context = useContext(LocationInfoContext);

    if (!canDoIt) {
        return null;
    }

    return (
        <>
            {locationId && (
                <IconButton onClick={handleDeleteFile(trigger, dispatch, +locationId, +row.id, context)}>
                    <Delete/>
                </IconButton>
            )}
        </>
    );
};
